import { createFileRoute } from '@tanstack/react-router';

import { NotFound } from '@/features/NotFound';

export const Route = createFileRoute('/$')({
  component: NotFound,
});
